export const POLICY_OPTIONS = [
  { type: 'TERMS_OF_SERVICE', label: '서비스 이용약관' },
  { type: 'PRIVACY_POLICY', label: '개인정보 처리방침' },
];

export const LIST_FILTER_OPTIONS = [
  { type: 'ALL', label: '전체' },
  ...POLICY_OPTIONS,
];

export const POLICY_TYPE_LABELS = Object.fromEntries(
  POLICY_OPTIONS.map((option) => [option.type, option.label])
);

export const toDateTimeLocalValue = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60 * 1000);
  return local.toISOString().slice(0, 16);
};

export const toIsoDateTime = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('ko-KR');
};
